// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Payroll_UpdateExecutionAmountResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface Payroll_UpdateExecutionAmountResponseDados {
id: number
payroll_period_id: number
payment_rule_id: number
user_id: string
franchise_id: number
base_amount: number
revenue_tracked: number
expenses_tracked: number
total_deductions: number
net_amount: number
status: string
created_at: string
updated_at: string
despesa_id: number
paid_at: string
calculation_meta: string
}

export type Payroll_UpdateExecutionAmountResponse = ApiResponse<Payroll_UpdateExecutionAmountResponseDados>;

registerResponseContract('Payroll_UpdateExecutionAmountResponse', {
  id:                { type: 'number',  required: true },
  payroll_period_id: { type: 'number',  required: true },
  payment_rule_id:   { type: 'number',  required: true },
  user_id:           { type: 'string',  required: true },
  franchise_id:      { type: 'number',  required: true },
  base_amount:       { type: 'number',  required: true },
  revenue_tracked:   { type: 'number',  required: false },
  expenses_tracked:  { type: 'number',  required: false },
  total_deductions:  { type: 'number',  required: true },
  net_amount:        { type: 'number',  required: true },
  status:            { type: 'string',  required: true },
  created_at:        { type: 'string',  required: true },
  updated_at:        { type: 'string',  required: true },
  despesa_id:        { type: 'number',  required: false },
  paid_at:           { type: 'string',  required: false },
  calculation_meta:  { type: 'string',  required: false },
})
